<div class="w-full read-only--style z-99999">
    <p class="text-center text-lg">{{ readOnlyModeText }}</p>
</div>